import {setInfoValue} from "@/helpers/info-overview-helper";

export function generateCanvas() {
    setTimeout(() => {
        const canvas = document.querySelector('ol-map').querySelector('canvas')
        const img    = canvas.toDataURL('image/png')

        let imageValue = '<img src="' + img + '" style="width: 100%">'
        setInfoValue(window.geoLocationAttributeID, imageValue)
    }, 1000)
}
